import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import { RadioBoxGroup, RadioBoxOption, useMediaQuery } from '@offerzen/pinata-shame'
import CheckCircleIcon from '@offerzen/zenicon/CheckCircleIcon'

import AccessibleIcon from '@/CandidateExperience/components/AccessibleIcon'
import Toast, { useToast } from '@/CandidateExperience/components/Toast'

import styles from './styles'

const BannerContent = ({ isFeedbackSubmitted, isValidRecommendation, isSubmittingFeedback, submitFeedback = () => {} }) => {
  const { isTabletOrLarger } = useMediaQuery()
  const { visibleToast, showToast, hideToast } = useToast()

  const onError = () => {
    showToast({ theme: 'error', message: 'Sorry, your feedback was not submitted. Please try again.' })
  }

  if (isFeedbackSubmitted) {
    return (
      <div className={cx(styles.container, styles.successNotification)}>
        {isTabletOrLarger && <AccessibleIcon icon={CheckCircleIcon} />}
        <p>
          Thanks for your feedback. {isValidRecommendation ? "We'll show you more jobs like this." : 'You will no longer see this job.'}
        </p>
      </div>
    )
  }

  return (
    <>
      <Toast theme={visibleToast?.theme} message={visibleToast?.message} onDismiss={hideToast} />
      <form>
        <fieldset className={cx(styles.container, styles.fieldset)} aria-labelledby="recommend_similar_group_label">
          <div className={styles.legendGroup}>
            <legend id="recommend_similar_group_label" className={styles.label}>
              Would you like to see more jobs like this?
            </legend>
            <RadioBoxGroup
              name="recommend_similar_candidate"
              onChange={e => {
                submitFeedback({ validRecommendation: e.target.value, onError })
              }}
              className={styles.radioGroup}
              theme="dark">
              <RadioBoxOption value="yes" label="Yes" className={styles.radioOption} disabled={isSubmittingFeedback} />
              <RadioBoxOption value="no" label="No" className={styles.radioOption} disabled={isSubmittingFeedback} />
            </RadioBoxGroup>
          </div>
        </fieldset>
      </form>
    </>
  )
}

BannerContent.propTypes = {
  isFeedbackSubmitted: PropTypes.bool,
  submitFeedback: PropTypes.func,
  isValidRecommendation: PropTypes.bool,
  isSubmittingFeedback: PropTypes.bool,
}

export default BannerContent
